import styled from 'styled-components';

import * as S from '../components/BannerCarousel/BannerCarouselStyle';

export const BenefitCardListWrapper = styled.div(
	({ theme: { down, breakpoints } }) => `
		display: flex;
		flex-wrap: wrap;
		> div{
				z-index:9;
		}
		padding-bottom: 50px;
		padding-top: 50px;
		>div {
			width: calc(33.3% - 12px);
			margin-right: 18px;
			&:nth-child(3n) {
					margin-right: 0;
			}
		}
		${down(breakpoints.tb)} {
			>div{
					margin-right: 12px;
					&:nth-child(3n) {
							margin-right: 12px;
					}
					&:nth-child(2n) {
							margin-right: 0;
					}
					
					width: calc(50% - 6px);
				}
			}
			${down(breakpoints.md)} {
					>div{
							margin-right: 0;
							width: 100%;
							&:nth-child(3n) {
									margin-right: 0;
							}
					}
					padding-top: 10px;
			}
			.bannerimg {
				max-height: 250px;
			}
	`
);

export const HomepageBannerLeft = styled(S.HomepageBannerLeft)(
	({ theme: { down, breakpoints } }) => `
		${down(breakpoints.md)} {
				button{
					margin-top: 0;
				}
		}
	`
);
